import { render, staticRenderFns } from "./CsdsList.vue?vue&type=template&id=d9f5472c&scoped=true&"
import script from "./CsdsList.vue?vue&type=script&lang=js&"
export * from "./CsdsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9f5472c",
  null
  
)

export default component.exports